import React, { useEffect, useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Chart } from "react-google-charts";
import { Tabs, Tab, ListGroup, Spinner } from 'react-bootstrap'
import { Modal, ModalManager, Effect } from 'react-dynamic-modal';
import moment from 'moment'

import './index.css'
import { GrClose } from 'react-icons/gr'

export default function DeviceChart({ device, deviceData }) {
  const body = document.getElementsByTagName('body')[0];

  const [temperatures, setTemperatures] = useState([]);
  const [optionsTemperatura, setOptionsTemperatura] = useState();
  const [optionsUmidade, setOptionsUmidade] = useState();
  const [humidities, setHumidities] = useState([]);
  const [config, setConfig] = useState({});
  const [maxTemperature, setMaxTemperature] = useState()
  const [minTemperature, setMinTemperature] = useState()
  const [maxHumidity, setMaxHumidity] = useState()
  const [minHumidity, setMinHumidity] = useState()
  const [medTemperature, setMedTemperature] = useState(0)
  const [key, setKey] = useState('Temperatura');

  useEffect(() => {
    if (deviceData) {
      getTemperatures(deviceData)
      getHumidities(deviceData)
      calculateMedTemp(deviceData)
    }
  }, [])

  useEffect(() => {
    setConfig(device)
    setMaxTemperature(indexOfMax(temperatures))
    setMinTemperature(indexOfMin(temperatures))
    setMaxHumidity(indexOfMax(humidities))
    setMinHumidity(indexOfMin(humidities))
  }, [temperatures, humidities])


  const getTemperatures = (data) => {
    let temperaturesArray = []
    let titles = ["Horário", "Temperatura"]

    data.map((data) => {
      let appendArray = [moment.utc(data.createdAt).local().format('DD/MM/YYYY HH:mm:ss'), data.temperature];

      if (device?.config?.temperature?.max) {
        appendArray.push(device?.config?.temperature?.max)
        if (!titles.includes('Temperatura Máxima'))
          titles.push('Temperatura Máxima');
      }

      if (device?.config?.temperature?.min) {
        appendArray.push(device?.config?.temperature?.min)
        if (!titles.includes('Temperatura Mínima'))
          titles.push('Temperatura Mínima');
      }

      temperaturesArray.push(appendArray);
    })
    temperaturesArray.sort()
    temperaturesArray.unshift(titles)

    const options = {
      hAxis: {
        textStyle: { color: 'white' }
      },
      vAxis: {
        title: 'Temperatura (°C)',
        minValue: minTemperature,
      },
      curveType: 'line',
      colors: ['#35A0E6', '#FF0000', '#87CEEB'],
    };

    setOptionsTemperatura(options)
    setTemperatures(temperaturesArray)
  }

  const getHumidities = (data) => {
    let humiditiesArray = []
    let titles = ["Horário", "Umidade"];
    data.map((data) => {
      let appendArray = [moment.utc(data.createdAt).local().format('DD/MM/YYYY HH:mm:ss'), data.humidity];

      if (device?.config?.humidity?.max) {
        appendArray.push(device?.config?.humidity?.max)
        if (!titles.includes('Umidade Máxima'))
          titles.push('Umidade Máxima');
      }

      if (device?.config?.humidity?.min) {
        appendArray.push(device?.config?.humidity?.min)
        if (!titles.includes('Umidade Mínima'))
          titles.push('Umidade Mínima');
      }

      humiditiesArray.push(appendArray)
    })
    humiditiesArray.sort()
    humiditiesArray.unshift(titles)

    const options = {
      hAxis: {
        textStyle: { color: 'white' }
      },
      vAxis: {
        title: 'Umidade (%)',
        minValue: minHumidity,
      },
      curveType: "line",
      colors: ['#35A0E6', '#FF0000', '#87CEEB'],
    };

    setOptionsUmidade(options)
    setHumidities(humiditiesArray)
  }

  function calculateMedTemp(data) {
    let total = 0;
    data.forEach((item) => {
      total += item.temperature;
    });
    total = total / data.length;

    setMedTemperature(total.toFixed(2))
  }

  const indexOfMax = arr => {
    let newArr = []
    for (let i = 0; i < arr.length; i++) {
      let result = arr[i].filter(function (element) {
        return typeof element !== 'string';
      });
      newArr.push(result)
    }
    var novoArray = newArr.flat(1)
    var max = Math.max(...novoArray)
    return max
  }

  const indexOfMin = arr => {
    let newArr = []
    for (let i = 0; i < arr.length; i++) {
      let result = arr[i].filter(function (element) {
        return typeof element !== 'string';
      });
      newArr.push(result)
    }
    var novoArray = newArr.flat(1)
    var min = Math.min(...novoArray)
    return min
  }

  const style = {
    overlay: {
      position: 'fixed',
      top: '0%',
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
    },

    content: {
      border: '1px solid rgba(0, 0, 0, .2)',
      boxShadow: '0 5px 10px rgba(0, 0, 0, .3)',
      bottom: '15%',
      padding: '1rem'
    }
  }
  function showShart() {
    return (
      <Tabs
        id="controlled-tab-device-modal"
        activeKey={key}
        onSelect={(k) => setKey(k)}
      >
        <Tab eventKey="Temperatura" title="Temperatura">
          <div className={"my-pretty-chart-container"}>
            <Chart
              chartType="LineChart"
              loader={<div className="loading-chart">
                <Spinner animation="border" />
              </div>}
              width="100%"
              height="500px"
              data={temperatures}
              options={optionsTemperatura}
            />
            <br />
            <Row>
              <Col md={4}>
                <ListGroup as="ul">
                  <ListGroup.Item as="li" variant="danger">
                    Temperatura Máxima Registrada
                  </ListGroup.Item>
                  <ListGroup.Item as="li">{maxTemperature} °C</ListGroup.Item>
                </ListGroup>
              </Col>
              <Col md={4}>
                <ListGroup as="ul">
                  <ListGroup.Item as="li" variant="warning">
                    Temperatura Média Registrada
                  </ListGroup.Item>
                  <ListGroup.Item as="li">{medTemperature} °C</ListGroup.Item>
                </ListGroup>
              </Col>
              <Col md={4}>
                <ListGroup as="ul">
                  <ListGroup.Item as="li" variant="primary">
                    Temperatura Mínima Registrada
                  </ListGroup.Item>
                  <ListGroup.Item as="li">{minTemperature} °C</ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
          </div>
        </Tab>
        <Tab eventKey="Umidade" title="Umidade">
          <div>
            <Chart
              chartType="LineChart"
              width="100%"
              height="500px"
              data={humidities}
              options={optionsUmidade}
            />
            <br />
            <Row>
              <Col md={6}>
                <ListGroup as="ul">
                  <ListGroup.Item as="li" variant="danger">
                    Umidade Máxima Registrada
                  </ListGroup.Item>
                  <ListGroup.Item as="li">{maxHumidity} %</ListGroup.Item>
                </ListGroup>
              </Col>
              <Col md={6}>
                <ListGroup as="ul">
                  <ListGroup.Item as="li" variant="primary">
                    Umidade Mínima Registrada
                            </ListGroup.Item>
                  <ListGroup.Item as="li">{minHumidity} %</ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
          </div>
        </Tab>
      </Tabs>
    );
  }


  return (

    <div className="ChartCustom">
      {temperatures.length > 1 ? showShart() : (<span>Nada encontrado.</span>)}

    </div>
  );
}